import React from 'react';
import { Link } from 'react-router-dom';
import { 
  motion
} from "framer-motion"

let discordAlert = "The Council of Legends will soon open its doors to the privileged Heaven Keys holders 🗝";

const Footer = () => {
  return (
    <footer className="relative bg-black text-white pt-16 pb-10 pl-10 sm:pl-20 pr-10">
      {/* Resume/Menus */}
      <aside className="flex flex-wrap items-end justify-between container mx-auto">
        {/* Resume */}
        <article className="w-full mb-5 lg:mb-10 ">
          <h2 className="text-2xl italic font-bold mb-10">
            Legends Of The Past
          </h2>
          <p>
            Legends of the Past is a mobile game based on the people who
            shaped History.
          </p>

          <div className="mt-8 flex justify-center">
          <a
            href="mailto:company@legendsofthepast.gg"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              animation: "glowPulse 2s infinite"
            }}
            className="animate-pulse transform hover:scale-105 hover:shadow-2xl bg-[#FFD700] hover:bg-[#e6c200] text-black font-bold italic uppercase text-base md:text-lg px-6 py-3 rounded-xl transition-all duration-300"
          >
            CONTACT
          </a>

          <style>{`
            @keyframes glowPulse {
              0%, 100% { box-shadow: 0 0 0px #FFD700; }
              50% { box-shadow: 0 0 12px #FFD700; }
            }
          `}</style>

          </div>
          
        </article>
        {/* Social Networks */}
        <nav className="mb-10 order-2 lg:order-3">
          <ul className="flex space-x-3">
            {/* Discord */}
            <li>
              <a href="https://discord.gg/wYB7bsjVQ5">
                <figure>
                  <motion.img
                    whileHover={{ scale: 1.1 }}
                    src="/assets/social_networks/discord.svg"
                    alt="Discord"
                    title="Discord"
                    className="w-10"
                  />
                </figure>
              </a>
            </li>
            {/* Twitter */}
            <li>
              <a href="https://twitter.com/legends_of_past">
                <figure>
                  <motion.img
                    whileHover={{ scale: 1.1 }}
                    src="/assets/social_networks/twitter.svg"
                    alt="Twitter"
                    title="Twitter"
                    className="w-10"
                  />
                </figure>
              </a>
            </li>
          </ul>
        </nav>
        <a href="/">
          <motion.img
            whileHover={{ scale: 1.1 }}
            src="/assets/Icon_legends_of_the_past.svg"
            title="LEGENDS OF THE PAST"
            alt=""
            className="z-50 w-14 -top-1 lg:w-28 lg:-top-24 lg:left-0"
        /></a>
      </aside>
      {/* Supported by */}
      <aside className="container mx-auto mb-10">
        <h3 className="text-sm uppercase tracking-widest text-gray-400 mb-4">
          Supported by
        </h3>
        <a
          href="https://www.iledefrance.fr"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-6"
        >
          <img
            src="/assets/partners/region-ile-de-france-blanc.png"
            alt="Région Île-de-France"
            className="w-44 h-auto shrink-0"
          />
          <span>
            With the support of the{" "}
            <span className="whitespace-nowrap">Île-de-France</span> Region
          </span>
        </a>
      </aside>
      <div className="!bg-[#34384C]/80 h-px container mx-auto" />
      {/* Licence */}
      <aside className="flex mt-10 flex-wrap justify-between container mx-auto">
        {/* Banner */}
        <p className="shrink-0">2025 ©. All rights reserved.</p>
        {/* Licence documentations */}
        <ul className="flex flex-wrap">
          <li className="border-r border-white pr-3 mr-3 sm:pr-6 sm:mr-6">
            <Link to="/">Terms</Link>
          </li>
          <li>
            <Link to="/">Privacy Policy</Link>
          </li>
        </ul>
      </aside>
    </footer>
  );
};

export default Footer;
